import { createMuiTheme } from "@material-ui/core";

const mainTheme = createMuiTheme({
  palette: {
    primary: {
      dark: "#207324",
      main: "#69B64A",
      light: "#92D76D",
    },
    secondary: {
      dark: "#17191A",
      main: "#555759",
      light: "#B0B3B5"
    }
  }
});

export default mainTheme;
